// start:ng42.barrel
export * from './home.service';
// end:ng42.barrel

